const initialState = {
  ACTIVE_TENANT: null,
  LICENCES: null,
  SCOPES: null,
  SCOPES_NAMES: null,
  ROLES:null,
  ALL_ROLES:null,
  MEDIAS: null,
  AGENTS: null,
  SCOPE_AVAILABLE_LICENCES: null,
  AGENTS_IDS: null,
  CALL_FLOWS: null,
  IA_AGENTS: null,
  AGENT_PROFILES: null,
  QUEUES: null,
  chatFlows:null,
  whatsAppFlows:null,
  ST_GROUPS:null,
  VARIABLES: null,
  WORKFLOWS: null,
  ANALYTICS_PROFILES: null,
  PERMISSIONS: null,
  consentedApps: [],
  supervisedAgentDetails: null,
  supervisedAgentIds: [],
  callFlowsIds: [],
  partnerTenants: []
};
export const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_TENANT":
      return { ...state, ACTIVE_TENANT: action.payload };
    case "SET_LICENCES":
      return { ...state, LICENCES: action.payload };
    case "SET_SCOPES":
      return { ...state, SCOPES: action.payload };
          case "SET_ROLES":
      return { ...state, ROLES: action.payload };
      case "SET_PERMISSIONS":
      return { ...state, PERMISSIONS: action.payload };
           case "SET_ALL_ROLES":
      return { ...state, ALL_ROLES: action.payload };
    case "SET_SCOPES_NAMES":
      return { ...state, SCOPES_NAMES: action.payload };
    case "SET_MEDIAS":
      return { ...state, MEDIAS: action.payload };
    case "SET_AGENTS":
      return { ...state, AGENTS: action.payload };
       case "SET_GROUPS":
      return { ...state, ST_GROUPS: action.payload };
      case "SET_AGENTS_PROFILES":
      return { ...state, agentsProfiles: action.agentsProfiles };
    case "SET_AVAILABLE_LICENCES":
      return { ...state, SCOPE_AVAILABLE_LICENCES: action.payload };
    case "SET_AGENTS_IDS":
      return { ...state, AGENTS_IDS: action.payload };
    case "SET_CALL_FLOWS":
      return { ...state, CALL_FLOWS: action.payload };
    case "SET_IA_AGENTS":
      return { ...state, IA_AGENTS: action.payload };
      case "SET_CHAT_FLOWS":
        return { ...state, chatFlows: action.payload };
      case "SET_WHATSAPP_FLOWS":
        return { ...state, whatsAppFlows: action.payload };
    case "SET_AGENT_PROFILES":
      return { ...state, AGENT_PROFILES: action.payload };
    case "SET_QUEUES":
      return { ...state, QUEUES: action.payload };
    case "SET_CONSENTED_APPS":
      return { ...state, consentedApps: action.payload };
    case "ADD_CONSENTED_APP":
      return { 
        ...state, 
        consentedApps: [...state.consentedApps, action.payload] 
      };
    case "SET_SUPERVISED_AGENT_DETAILS":
      return { ...state, supervisedAgentDetails: action.payload };
    case "SET_SUPERVISED_AGENT_IDS":
      return { ...state, supervisedAgentIds: action.payload };
    case "SET_CALL_FLOWS_IDS":
      return { ...state, callFlowsIds: action.payload };
    case "SET_PARTNER_TENANTS":
      return { ...state, partnerTenants: action.payload };
    case "SET_VARIABLES":
      return { ...state, VARIABLES: action.payload };
    case "SET_WORKFLOWS":
      return { ...state, WORKFLOWS: action.payload };
    case "SET_ANALYTICS_PROFILES":
      return { ...state, ANALYTICS_PROFILES: action.payload };

    default:
      return state;
  }
};
